import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';

function PartnerLogin() {
  const location = useLocation();
  const navigate = useNavigate();
  const { login } = useAuth();

  const [error, setError] = useState('');

  useEffect(() => {
    const authenticatePartner = async () => {
      try {
        const params = new URLSearchParams(location.search);
        const token = params.get('token');

        if (!token) {
          setError('Token de autenticação não encontrado.');
          return;
        }

        const response = await fetch(
          'https://api.hub4food.colab4food.com/api/partner-login/consume',
          {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ token }),
          }
        );

        const data = await response.json();

        if (!response.ok) {
          throw new Error(
            data.error || 'Não foi possível autenticar.'
          );
        }

        login({
          userId: data.user.id,
          username: data.user.name,
          user_permission_id:
            data.user.user_permission_id
        });

        navigate('/ideationPlatform', {
          replace: true
        });

      } catch (error) {
        console.error(
          'Erro no login Colab4Food:',
          error
        );

        setError(error.message);
      }
    };

    authenticatePartner();
  }, [location.search, login, navigate]);

  if (error) {
    return (
      <div>
        <h2>Erro de autenticação</h2>
        <p>{error}</p>
      </div>
    );
  }

  return (
    <div>
      <p>A iniciar sessão...</p>
    </div>
  );
}

export default PartnerLogin;